import { render, staticRenderFns } from "./SantanderEmissao.vue?vue&type=template&id=63c034cd&scoped=true&"
import script from "./SantanderEmissao.vue?vue&type=script&lang=js&"
export * from "./SantanderEmissao.vue?vue&type=script&lang=js&"
import style0 from "./SantanderEmissao.vue?vue&type=style&index=0&id=63c034cd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c034cd",
  null
  
)

export default component.exports